import {Redirect, useLocation} from 'react-router-dom';
import qs from 'query-string';
import {Grid, Segment} from 'semantic-ui-react';
import MainLayout from '../layouts/main';
import {useSelector} from 'react-redux';
import LoginForm from './form';
import {AUTHENTICATED} from '../../redux/constants';

function LoginPage() {
  const isAuthenticated = useSelector(state => state.auth.status === AUTHENTICATED);
  const location = useLocation();

  if (isAuthenticated) {
    const nextParam = qs.parse(location.search).next;
    const nextURL = nextParam ? nextParam.replace(';', '&') : '/report';
    return (<Redirect to={nextURL}/>);
  }

  return (
    <MainLayout loginRequired={false} consultPackageRequired={false} packageRequired={false}>
      <Grid centered verticalAlign='middle' size='big'>
        <Grid.Column mobile={12} tablet={10} computer={8}>
          <Segment>
            <LoginForm/>
          </Segment>
        </Grid.Column>
      </Grid>
    </MainLayout>
  );
}

export default LoginPage;
